import { defaultHttpClient } from '../../httpClient';
import type { GetMarketParentCategoriesResponse } from './types';

export const getMarketParentCategories = (marketId: number) => {
  return defaultHttpClient
    .request<GetMarketParentCategoriesResponse>({
      method: 'GET',
      url: `/api/v2/markets/${marketId}/parent/categories`,
    })
    .then(result => result.data);
};
